import type { FaireProductEntity } from "../../entity_types/product";

export const p_aud73vzpr2: FaireProductEntity = {
  token: "p_aud73vzpr2",
  type: "product",
  name: "Joielle 18K Gold Non-Tarnish Baguette CZ Hoop Earrings",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/5b493520595d6d6d138c33987a7863e1fe5ddca96c2c8bdc37749a3776258236.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0f40805f9de3701a0a152f2100d74f10430fb105f85eddc5dbd7a736be891c72.jpeg",
    "https://cdn.faire.com/fastly/fa78ce2b0facb281d147c5c391368fdb89682655ff65a34c02c11c3df19562cd.jpeg",
    "https://cdn.faire.com/fastly/f7da16f2c62c4a61d3b249214b0e0562d8b65c364b75dbf5e4aeb9d6121a468e.jpeg",
    "https://cdn.faire.com/fastly/32c9b5a6f5d088081e7c47d2772d48929402e1612ccd7a8f703565059a0feee9.jpeg",
  ],
  priceDollars: 11.29,
  description:
    "18K Gold Non-Tarnish Baguette CZ Hoop Earrings\n18K Gold Plating\nStainless Steel\nCubic Zirconia\nMeasurement (L x W inch): 0.57 x 0.18\n\n- Lead-free, Nickel-safe\n- Hypoallergenic\n- Water Resistant",
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:14.074Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
